export const isEmptyString = (val: any) => (typeof val === "string" || val instanceof String) && val.trim() === "";
